import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { trimStringsDeep } from './string-utils';

@Injectable()
export class TrimInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const body = req.body;
    if (body === null || body === undefined) {
      return next.handle(req);
    }
    if (body instanceof FormData || body instanceof Blob || body instanceof ArrayBuffer) {
      return next.handle(req);
    }
    if (typeof body === 'string') {
      const trimmed = body.trim();
      if (trimmed === body) {
        return next.handle(req);
      }
      return next.handle(req.clone({ body: trimmed }));
    }
    if (typeof body === 'object') {
      return next.handle(req.clone({ body: trimStringsDeep(body) }));
    }
    return next.handle(req);
  }
}
